// web_managerSupplier_supplierDelete 删除供应商复制

const __request = require(`@/lib/data-service/default/__request/__request_contentType_form`);

// 接口地址：http://192.168.0.15:8080/doc.html#/所有接口/manager-supplier-controller/deleteSupplierUsingPOST

export default function web_managerSupplier_supplierDelete(pParameter) {
  if (!pParameter) pParameter = {};
  const supplierId = pParameter.supplierId || ''
  let params = {}
  params.method = 'POST'
  params.urlSuffix = '/web/managerSupplier/supplierDelete'
  params.data = {
    supplierId
  }
  return new Promise(function (resolve, reject) {
    resolve(__request(params))
  })
}
